import nsiLogo from "./nsi-logo.png";
import nsiLogoWhite from "./nsi_logo_white.png";
import placeholderPerson from "./placeholder-person.png";
import headerLogo from "./via-logo.png";
import sharepointLogo from "./sharepoint-logo.png";

const assets = {
  images: {
    nsiLogo: nsiLogo,
    nsiLogoWhite: nsiLogoWhite,
    placeholderPerson: placeholderPerson,
    headerLogo: headerLogo,
    sharepointLogo: sharepointLogo,
  },
};

export default assets;
